import { Registreren } from './registreren';

require('./registreren.scss');

export const myRegistreren = {
  template: require('./registreren.html'),
  controllerAs: 'ctrl',
  controller: Registreren,
};
